import { classes } from 'html-classes';

import Icon from '../Icon/Icon';

export interface CarouselIconProps {
  onClick: () => void;
  position: 'right' | 'left';
  variant: 'fill' | 'white' | 'transparent';
  className?: string;
  hide?: boolean;
  disabled?: boolean;
  iconClassName?: string;
  attributeName?: string;
  iconSize?: number;
}

const CarouselIcon = ({
  onClick,
  attributeName,
  position,
  variant,
  className,
  hide,
  disabled,
  iconClassName,
  iconSize = 24,
}: CarouselIconProps) => {
  if (hide) {
    return null;
  }

  return (
    <div
      data-button={attributeName}
      className={classes([
        `button-circle-arrow`,
        `_${position}`,
        `variant-${variant}`,
        disabled && '_disabled',
        className,
      ])}
      onClick={disabled ? undefined : onClick}
    >
      <Icon type="chevron" size={iconSize} className={iconClassName} />
    </div>
  );
};

export default CarouselIcon;
